export default "__VITE_ASSET__CxAX49Jj__"